import React, { lazy, Suspense } from "react";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import styled from "styled-components";

import { SalesDashboardTabs } from "./summary/sales-tabs";
import { SalesChartSection } from "./details/sales-chart-section";
import { SalesDashboardHeaderSection } from "./sales-header-section";
import { SalesDashboardTargetData } from "./summary/sales-target-data";
import { SalesDashboardSummary } from "./summary/sales-dashboard-summary";
import { SalesDashboardAverageSummary } from "./summary/sales-average-summary";
import { SalesDataTableSkeleton } from "./details/sales-data-table.skeleton";

const SalesDataTable = lazy(() =>
  import("./details/sales-data-table").then((mod) => ({
    default: mod.SalesDataTable,
  }))
);

const Section = styled.section`
  position: relative;
  padding: 0 16px 24px;
  margin: 0 auto;
`;

const Article = styled.article`
  background: #fff;
  padding: 16px 0;
  border-radius: 16px;
  overflow: hidden;
`;

export function SalesDashboard() {
  return (
    <Section>
      <SalesDashboardHeaderSection />
      <Article>
        <SalesDashboardTabs />
        <SalesDashboardSummary />
        <SalesDashboardAverageSummary />
        <SalesDashboardTargetData />
        <SalesChartSection />

        <LazyLoadComponent
          placeholder={<SalesDataTableSkeleton />}
          threshold={150}
        >
          <Suspense fallback={<SalesDataTableSkeleton />}>
            <SalesDataTable />
          </Suspense>
        </LazyLoadComponent>
      </Article>
    </Section>
  );
}
